import translations from '../../components/location/ts/nl';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('nl', translations);
